import { render, staticRenderFns } from "./NewSectionPanel.vue?vue&type=template&id=7da41df2&"
import script from "./NewSectionPanel.vue?vue&type=script&lang=ts&"
export * from "./NewSectionPanel.vue?vue&type=script&lang=ts&"
import style0 from "./NewSectionPanel.vue?vue&type=style&index=0&id=7da41df2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports